import { action, computed, makeObservable, observable } from 'mobx';
import { Program } from '../../models';

export class ProgramsPageUiStore {
  @observable programs: Program[] = [];

  @observable isShowCreateProgramModal: boolean = false;

  @observable isShowCreateProgramErrorMessage: boolean = false;

  @observable programIdToArchive?: number;

  constructor() {
    makeObservable(this);
  }

  @action
  resetStates(): void {
    this.programs = [];
    this.isShowCreateProgramModal = false;
    this.isShowCreateProgramErrorMessage = false;
    this.programIdToArchive = undefined;
  }

  @action
  setPrograms(programs: Program[]): void {
    this.programs = programs;
  }

  @action
  addProgram(program: Program): void {
    this.programs.push(program);
  }

  @action
  archiveProgram(programId: number): void {
    const program = this.programs.find((program) => program.programId === programId);
    if (program) {
      program.status = false;
    }
    this.isShowCreateProgramErrorMessage = this.hasActiveProgram;
  }

  @action
  setShowCreateProgramModal(isShow: boolean): void {
    this.isShowCreateProgramErrorMessage = isShow && this.hasActiveProgram;
    this.isShowCreateProgramModal = isShow && !this.isShowCreateProgramErrorMessage;
  }

  @action
  setProgramIdToArchive(programId?: number): void {
    this.programIdToArchive = programId;
  }

  @computed
  get hasActiveProgram(): boolean {
    return this.programs.some((program) => program.status);
  }

  @computed
  get hasNoPrograms(): boolean {
    return this.programs.length === 0;
  }

  @computed
  get isShowArchiveProgramModal(): boolean {
    return this.programIdToArchive !== undefined;
  }
}
